if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form || this.submitHandler) return;
      const variant = this.form.querySelector('[name="id"]');
      if (variant) variant.disabled = false;
      this.submitHandler = this.onSubmitHandler.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
      this.submitButton = this.querySelector('[type="submit"]');
      this.cart = document.querySelector('cart-drawer');
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.submitHandler);
      this.submitHandler = null;
    }

    getSubmitButtons() {
      return Array.from(document.querySelectorAll('button[name="add"]')).filter((button) => button.form === this.form || this.form.contains(button));
    }

    setSubmitting(submitting) {
      this.submitting = submitting;
      this.form.dataset.vrSubmitting = String(submitting);
      this.form.setAttribute('aria-busy', String(submitting));
      const blocked = submitting || this.form.dataset.variantPending === 'true' || this.form.dataset.variantUnavailable === 'true' || this.form.dataset.variantError === 'true';
      this.getSubmitButtons().forEach((button) => {
        button.disabled = blocked;
        button.setAttribute('aria-disabled', String(blocked));
        button.classList.toggle('loading', submitting);
        button.querySelector('[data-addtocart-text]')?.classList.toggle('hidden', submitting);
        button.querySelector('.spinner-loading-btn')?.classList.toggle('hidden', !submitting);
      });
      this.form.querySelectorAll('.shopify-payment-button').forEach((payment) => {
        if (blocked) {
          if (payment.dataset.vrPreviousHidden === undefined) payment.dataset.vrPreviousHidden = payment.hidden ? 'true' : 'false';
          payment.hidden = true;
        } else if (payment.dataset.vrPreviousHidden !== undefined) {
          payment.hidden = payment.dataset.vrPreviousHidden === 'true';
          delete payment.dataset.vrPreviousHidden;
        }
      });
    }

    async onSubmitHandler(event) {
      event.preventDefault();
      if (this.submitting) return;
      if (this.form.dataset.variantPending === 'true' || this.form.dataset.variantError === 'true') {
        this.handleErrorMessage('Espera a que se actualice la selección antes de añadirla al carrito.');
        return;
      }
      const button = event.submitter || this.submitButton;
      const variant = this.form.querySelector('[name="id"]');
      if (button?.disabled || this.form.dataset.variantUnavailable === 'true' || !variant?.value) return;
      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }
      this.handleErrorMessage();
      this.setSubmitting(true);
      const formData = new FormData(this.form);
      this.cart = document.querySelector('cart-drawer');
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.section || section.id).join(','));
        formData.append('sections_url', window.location.pathname);
      }
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;
      try {
        const response = await fetch(routes.cart_add_url, config);
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          const message = 'No pudimos añadir esta selección. Revisa la disponibilidad y la cantidad e inténtalo nuevamente.';
          this.handleErrorMessage(message);
          publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: message, message });
          return;
        }
        document.querySelectorAll('.product-cart-sticky, .product-cart-sticky-detail').forEach((element) => element.classList.remove('active'));
        if (!this.cart) {
          window.location.assign(routes.cart_url);
          return;
        }
        if (this.cart.renderContents(result)) this.cart.show(button);
        else await this.cart.openDrawer(undefined, button);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
      } catch (error) {
        this.handleErrorMessage('No pudimos confirmar si se añadió el producto. Revisa tu carrito antes de volver a intentarlo.');
      } finally {
        this.setSubmitting(false);
      }
    }

    handleErrorMessage(message = '') {
      let wrapper = this.querySelector('.product-form__error-message-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'product-form__error-message-wrapper';
        wrapper.setAttribute('role', 'alert');
        this.prepend(wrapper);
      }
      let target = wrapper.querySelector('.product-form__error-message');
      if (!target) {
        target = document.createElement('span');
        target.className = 'product-form__error-message form-message error';
        wrapper.append(target);
      }
      wrapper.hidden = !message;
      target.textContent = message;
    }
  });
}
